
import CursorEffectSection from './CursorEffect';
import { useLanguage } from '../contexts/LanguageContext';

export default function SliderWrap() {
    const { language } = useLanguage();

    return (<section className="slider_wrap">
        <div data-wf--global-section-space--section-space="large" className="g_section_space w-variant-8cc18b30-4618-8767-0111-f6abfe45aaa3">
        </div>
         <CursorEffectSection/>
        <div className="slider_contain u-container-full">
            <div className="slider_layout u-grid-flex">
                <div className="slider_content u-column-8">
                    <div data-animate="blur" data-current-year className="eyebrow_wrap u-display-inline-flex u-text-style-h5">
                        <div className="eyebrow_text">
                            {language === 'ar' ? (
                                <>
                                    جعل حياتك أسهل،
                                    <span style={{color:'#9370F2'}}> ملف واحد في المرة</span>
                                </>
                            ) : (
                                <>
                                    Making your life easier,
                                    <span style={{color:'#9370F2'}}> one file at a time</span>
                                </>
                            )}
                        </div>
                    </div>
                    <h2 data-animate="blur" className="slider_title u-text-style-zrome">
                        {language === 'ar' ? (
                            'لخص يعيد تعريف الإنتاجية. يحول الذكاء الاصطناعي لدينا الصوت والفيديو إلى ملخصات دقيقة ونسخ كاملة ونقاط رئيسية، مما يمكن الطلاب والمهنيين والفرق من التصرف بشكل أسرع.'
                        ) : (
                            'Audiosum redefines productivity. Our AI turns audio and video into precise summaries, full transcripts and key takeaways, empowering students, professionals, and teams to act faster.'
                        )}
                    </h2>
                </div>
            </div>

    
        </div>
        <div data-wf--global-section-space--section-space="large" className="g_section_space w-variant-8cc18b30-4618-8767-0111-f6abfe45aaa3">
        </div>
    </section>
    )

}